import { useEffect, useState } from "react";
import "../server";
import "../styles/admin.scss";
import { Add, DeleteDate, GetAll, GetDate, Login } from "../server";
import { GetTravelData } from "../Location";

function DateData(data, travelData, Remove, setLoading) {
    return (
        <tr>
            <td>{travelData[data.data.id].name}</td>
            <td>{data.data.startDate}</td>
            <td>{data.data.endDate}</td>
            <td>
                <button
                    className="btn2"
                    onClick={() => {
                        setLoading(true);
                        DeleteDate(data.id).then(() => {
                            Remove(data.id);
                            setLoading(false);
                        });
                    }}
                >
                    Устгах
                </button>
            </td>
        </tr>
    );
}

export default function Admin() {
    const [isLogin, setLogin] = useState(false);
    const [data, setData] = useState([]);
    const [travelData, setTravelData] = useState(null);
    const [loading, setLoading] = useState(true);

    function Remove(id) {
        const d = data.filter((i) => i.id !== id);
        setData(d);
    }
    function AddR(da) {
        const d = [...data, da];
        setData(d);
    }
    useEffect(() => {
        if (!isLogin) {
            return;
        }
        GetTravelData().then((r) => {
            setTravelData(r);
            GetAll().then((res) => {
                setData(res);
                setLoading(false);
                console.log("Asd");
            });
        });
        
    }, [isLogin]);
    if (!isLogin) {
        return (
            <div className="adminPage">
                <div className="adminPage-form">
                    <div className="form-set">
                        <label>User Name</label>
                        <input id="mail" type="email"></input>
                    </div>
                    <div className="form-set">
                        <label>Password</label>
                        <input id="pass" type="password"></input>
                    </div>
                    <button
                        className="btn"
                        onClick={() => {
                            console.log(process.env.REACT_APP_FIREBASE_API_KEY);
                            Login({
                                mail: document.getElementById("mail").value,
                                pass: document.getElementById("pass").value,
                            }).then((res) => {
                                if (res == 1) {
                                    setLogin(true);
                                } else {
                                    alert("error");
                                }
                            });
                        }}
                    >
                        Нэвтрэх
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="adminPage">
            <table>
                <tr>
                    <th>Аялалын нэр</th>
                    <th>Эхлэх огноо</th>
                    <th>Дуусах огноо</th>
                    <th> </th>
                </tr>
                {data.map((d) => DateData(d, travelData, Remove, setLoading))}
            </table>
            <div className="adminPage-main">
                <div className="form-set">
                    <label>Аялалын нэр </label>
                    <select id="adminNumber">
                        {travelData &&
                            travelData.map((d, i) => {
                                if (i == 0) {
                                    return;
                                }
                                return (
                                    <option value={i} key={i}>
                                        {d.name}
                                    </option>
                                );
                            })}
                    </select>
                </div>
                <div className="form-set">
                    <label>Эхлэх огноо </label>
                    <input id="adminStartDate" type="date"></input>
                </div>
                <div className="form-set">
                    <label>Дуусах огноо </label>
                    <input id="adminEndDate" type="date"></input>
                </div>
                <button
                    className="btn"
                    onClick={() => {
                        setLoading(true);
                        Add({
                            id: document.getElementById("adminNumber").value,
                            startDate:
                                document.getElementById("adminStartDate").value,
                            endDate:
                                document.getElementById("adminEndDate").value,
                        }).then((r) => {
                            AddR(r);
                            setLoading(false);
                        });
                    }}
                >
                    Нэмэх
                </button>
            </div>
            {loading ? <div className="loading">LOADING...</div> : <div></div>}
        </div>
    );
}
